import Icon from "@/components/site/Icon";
import { TRUST_PILLARS } from "@/data/content";

export default function TrustStrip() {
  return (
    <section className="bg-[color:var(--brand-navy)]" data-testid="section-trust-strip">
      <div className="container-x py-12 sm:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {TRUST_PILLARS.map((p) => (
            <div key={p.title} className="flex items-start gap-4">
              <span className="inline-flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-white/10 border border-white/15">
                <Icon name={p.icon} className="h-6 w-6 text-[color:var(--brand-green)]" />
              </span>
              <div>
                <h3 className="text-white font-bold text-base">{p.title}</h3>
                <p className="text-white/70 text-sm mt-0.5">{p.text}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
